module.exports = __webpack_public_path__ + "static/media/Jingwan Wang.64606f3d.png";